export { LoyaltyController as Loyalty, useLoyaltyModal } from './loyalty-controller';
